module.exports = __webpack_public_path__ + "img/spartan-build-design-01-square.ad70290f.jpg";